// Where a knowledge doc LIVES on the site, from its id. One mapping for the
// server (search hits carry `url`, so NoVA can navigate_app to the page a
// fact came from) and the client (citation chips link there) — the
// frontend copy under src/data/ is generated by generate-entities.mjs.
//   platform-<section>          the books on /docs            → /docs#<section>
//   concept-<page>-<section>    a concept page                → /concepts/<page>?sec=<page>-<section>
//   book-module-<slug>          the short modules book        → /platform/<slug> (the module's site page)
//   brain-<slug>                the plane's brain             → /admin/brain/page/<slug>
//   anything else               an organization document      → the org's Knowledge module (needs orgId)
// A link is never a widening: every target route enforces its own access.
// ([[nova-knowledge-seams]] — "show me the seams table" used to end in
// find_on_page on whatever screen was open.)

export const CONCEPT_PAGES = ['ambient-screen', 'portfolio', 'revenue-cycle'];

// modules-book.md `## ` slugs → the public site page for that module.
const MODULE_PAGES = {
  'the-frame': '/platform',
  nqube: '/platform/nqube',
  agentos: '/platform/agentos',
  'agent-io': '/platform/agent-io',
  'nventr-agent': '/platform/nventr-agent',
  knowledge: '/platform/knowledge',
  integrations: '/platform/integrations',
  listen: '/platform/listen',
  'human-review': '/platform/human-review',
  reachout: '/platform/reachout',
  athena: '/platform/athena',
  devops: '/platform/devops',
  'neural-net-training-center': '/platform/training-center',
  'app-kit': '/app-kit',
};

export function knowledgeDocUrl(docId, { orgId } = {}) {
  const id = String(docId || '');
  if (!id) return null;
  if (id.startsWith('brain-')) return `/admin/brain/page/${encodeURIComponent(id.slice('brain-'.length))}`;
  if (id.startsWith('platform-')) return `/docs#${encodeURIComponent(id.slice('platform-'.length))}`;
  if (id.startsWith('concept-')) {
    const rest = id.slice('concept-'.length);
    const page = CONCEPT_PAGES.find((p) => rest === p || rest.startsWith(`${p}-`));
    if (!page) return null;
    // `concept-<page>-page` is the header row (title + hero): the page top.
    if (rest === page || rest === `${page}-page`) return `/concepts/${page}`;
    return `/concepts/${page}?sec=${encodeURIComponent(rest)}`;
  }
  if (id.startsWith('book-module-')) return MODULE_PAGES[id.slice('book-module-'.length)] || '/platform';
  if (/^(site|pricing)-/.test(id) || id.startsWith('book-')) return null; // public site facts: no single page
  return orgId ? `/orgs/${orgId}/knowledge` : null;
}

export function knowledgeDocKind(docId) {
  const id = String(docId || '');
  if (id.startsWith('brain-')) return 'brain';
  if (id.startsWith('platform-')) return 'docs';
  if (id.startsWith('concept-')) return 'concept';
  if (id.startsWith('book-module-')) return 'site';
  return 'org';
}
